export interface TableData {
  key: string;
  startTime: string;
  spentTime: number;
  ring: number;
  critical: boolean;
  description?: string;
  note: string | undefined | null;
}

export interface TaskTimeInfo {
  id: string;
  ring: number;
  ended: boolean;
}

export const SHOW_MORE_ON_MOBILE_STATE_KEYS = {
  METADATA: 'metadata',
  TASKS: 'tasks',
  NOTES: 'notes',
  GRAPH: 'graph',
  FILES: 'files',
} as const;

export type ShowMoreOnMobileStateKeys =
  (typeof SHOW_MORE_ON_MOBILE_STATE_KEYS)[keyof typeof SHOW_MORE_ON_MOBILE_STATE_KEYS];

export type ShowMoreOnMobileState = Record<ShowMoreOnMobileStateKeys, boolean>;
